import {
  createContext,
  PropsWithChildren,
  ReactElement,
  useContext,
  useMemo,
  useState,
} from "react";

export type GDPRStatus = "pending" | "error" | "resolved";

export type GDPRStore = {
  // hotjar, snowplow, VWO, etc.
  marketing: boolean;
  setMarketing(value: boolean): void;
  // GA, etc.
  analytics: boolean;
  setAnalytics(value: boolean): void;
  // feedback widget?
  performance: boolean;
  setPerformance(value: boolean): void;

  status: GDPRStatus;
  setStatus(status: GDPRStatus): void;
};

export const GDPRContext = createContext<GDPRStore | null>(null);

export function GDPRProvider({ children }: PropsWithChildren): ReactElement {
  const [marketing, setMarketing] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [performance, setPerformance] = useState(false);
  const [status, setStatus] = useState<GDPRStatus>("pending");

  const value = useMemo(
    (): GDPRStore => ({
      marketing,
      setMarketing,
      analytics,
      setAnalytics,
      performance,
      setPerformance,
      status,
      setStatus,
    }),
    [marketing, analytics, performance, status],
  );

  return <GDPRContext.Provider value={value}>{children}</GDPRContext.Provider>;
}

export function useGDPRStore(): GDPRStore {
  const store = useContext(GDPRContext);
  if (!store) {
    throw new Error("useGDPRStore must be used within GDPRProvider");
  }

  return store;
}
